import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApplicationCode } from "configs";
import uniqBy from "lodash/uniqBy";
import {
  authGetMeService,
  authGetUserInfoService,
  organizationListShortService,
} from "services";
import {
  saveTenantCode,
  saveOrgId,
  getDefaultOrgId,
  setDefaultOrgId,
} from "utils";

export const fetchingUserSessionAction = createAsyncThunk(
  "auth/fetchingUserSession",
  async () => {
    const getMeRes = await authGetMeService();
    return getMeRes?.data;
  }
);

export const initUserSessionAction = createAsyncThunk(
  "auth/initUserSession",
  async () => {
    const userInfoRes = await authGetUserInfoService();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let listOrg: any[] =
      userInfoRes?.data?.organizations?.filter(
        (org) => org?.application?.code === ApplicationCode && org.employeeId
      ) || [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let apps: any[] = [];
    apps = uniqBy(
      userInfoRes?.data?.organizations?.filter(
        (org) => org?.employeeId && org?.application?.code !== ApplicationCode
      ),
      "application.code"
    )?.map((org) => org.application);

    if (userInfoRes?.data?.isSuperAdmin) {
      try {
        const orgRes = await organizationListShortService({
          limit: 1000,
          // tenantId: -1,
        });
        listOrg = orgRes?.data?.items?.map((i) => ({
          ...i,
          tenantCode: i.tenant.code,
        }));
      } catch {
        // Handle error
      }
    }
    let orgSelected;
    const orgDefaultId = getDefaultOrgId(userInfoRes.data.id);
    if (!orgDefaultId) {
      orgSelected = listOrg?.[0];
      setDefaultOrgId(userInfoRes.data.id, orgSelected?.id as number);
      saveTenantCode(orgSelected?.tenantCode as string);
      saveOrgId(String(orgSelected?.id));
    } else {
      orgSelected = listOrg?.find(
        (item) => String(item.id) === String(orgDefaultId)
      );
      if (!orgSelected) {
        orgSelected = listOrg?.[0];
      }
      saveTenantCode(String(orgSelected?.tenantCode ?? ""));
      saveOrgId(String(orgSelected?.id));
    }
    return {
      user: {
        ...userInfoRes?.data,
        organizations: listOrg,
        apps,
      },
      orgSelected,
      userAppRole:
        orgSelected?.userAppRole ||
        (userInfoRes?.data?.isSuperAdmin ? "Admin" : "Employee"),
    };
  }
);
